import { useHistory, Route } from 'react-router-dom';
import React from 'react';

import { ProfileWrap } from './styled';
import { useLocation } from '../../app/hooks';
import AboutLifeTales from './about-lifetales';
import AnimatedNavWrap from '../../app/navigation/animated-nav-wrap';
import ContactMethods from './contact-methods';
import NotificationSettings from './notification-settings';
import ProfileEdit from './profile-edit';
import ProfileHeader from './profile-header';
import { useMyChildJournals } from 'account-dashboard/hooks';
import { ConfirmBar, BackButton } from 'account-dashboard/styled';
import Chevron from 'account-dashboard/chevron';

const ProfileDetail = () => {
  const { push, goBack } = useHistory();

  const location = useLocation();
  const { journals } = useMyChildJournals();
  const hasAssignedJournal = journals.every((journal) => journal?.state !== "initialized");

  return (
    <ProfileWrap>
      <ProfileHeader />
      <ContactMethods />
      {/* <NotificationSettings /> */}
      <AboutLifeTales />
      <AnimatedNavWrap location={location}>
        <Route path="/profile/edit" component={ProfileEdit} key="profile-edit" />
      </AnimatedNavWrap>
      {hasAssignedJournal && <ConfirmBar style={{ backgroundColor: 'white', width: '100%', padding: '30px' }} >
        <BackButton type="button" onClick={goBack}>
          <Chevron direction="left" />
          Back
        </BackButton>
      </ConfirmBar>}
    </ProfileWrap>
  );
};

export default ProfileDetail;
